import { useEffect } from "react";

const siteUrl = import.meta.env.VITE_SITE_URL ?? "https://example.com";

const eventJsonLd = {
  "@context": "https://schema.org",
  "@type": "Event",
  "name": "Mude1Hábito Experience 3ª Edição",
  "description": "Uma manhã dedicada ao cuidado com a saúde, ao bem-estar e à descoberta de novas formas de se movimentar. Evento gratuito com Yoga, Meditação, Funcional, Beach Tennis, Padel e muito mais em Belo Horizonte.",
  "url": `${siteUrl}/`,
  "image": "https://static.readdy.ai/image/13e887e1245ef2a30f63772c795d1a11/c80e79c7ca571adb127a415649a420b0.jpeg",
  "startDate": "2026-04-12T07:30:00-03:00",
  "endDate": "2026-04-12T12:20:00-03:00",
  "eventStatus": "https://schema.org/EventScheduled",
  "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
  "isAccessibleForFree": true,
  "inLanguage": "pt-BR",
  "organizer": {
    "@type": "Organization",
    "name": "Mude1Hábito",
    "url": `${siteUrl}/`
  },
  "location": {
    "@type": "Place",
    "name": "Arena 4Set",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "R. Líbero Leone, 259",
      "addressLocality": "Buritis, Belo Horizonte",
      "addressRegion": "MG",
      "postalCode": "30575-020",
      "addressCountry": "BR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": -19.9623,
      "longitude": -43.9934
    }
  },
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "BRL",
    "availability": "https://schema.org/InStock",
    "validFrom": "2026-01-01T00:00:00-03:00"
  }
};

const webPageJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Mude1Hábito Experience 3ª Edição – Evento de Saúde e Bem-estar em Belo Horizonte",
  "description": "Mude1Hábito Experience 3ª Edição – 12 de abril de 2026 na Arena 4Set, Buritis, Belo Horizonte. Evento gratuito de saúde, bem-estar e modalidades esportivas.",
  "url": `${siteUrl}/`,
  "inLanguage": "pt-BR",
  "dateModified": "2026-03-27",
  "isPartOf": {
    "@type": "WebSite",
    "name": "Mude1Hábito",
    "url": `${siteUrl}/`
  },
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": `${siteUrl}/`
      }
    ]
  }
};

function injectJsonLd(id: string, data: object): void {
  let el = document.getElementById(id) as HTMLScriptElement | null;
  if (!el) {
    el = document.createElement("script");
    el.id = id;
    el.type = "application/ld+json";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data, null, 2);
}

export default function SeoJsonLd() {
  useEffect(() => {
    injectJsonLd("jsonld-event", eventJsonLd);
    injectJsonLd("jsonld-webpage", webPageJsonLd);

    return () => {
      document.getElementById("jsonld-event")?.remove();
      document.getElementById("jsonld-webpage")?.remove();
    };
  }, []);

  return null;
}
